import { PcApiResponse } from '@/api/pc-api/types';
import { CiPermission, CsCenterType, SvcReviewStatusType } from '@/constants/svc';
import { PREFIX_PATH } from '@/lib/axios/axiosInterceptor';
import { api } from '@/utils/api';

type CiPermissionDoc = {
  fileUrl: string;
  originalFileName: string;
};

/** service.details.response.data */
export type SvcDetails = {
  businessNumber: string;
  channelUrl?: string;
  channelUuid?: string;
  ciPermission: CiPermission;
  ciPermissionDocs?: CiPermissionDoc[];
  contractCount: number;
  csCenterChannelUuid?: string;
  csCenterChannelUrl?: string;
  csCenterPhoneNumber?: string;
  csCenterType: CsCenterType;
  devIps: string[];
  hasElectronicAddress: boolean;
  id: string;
  isUpdatable?: boolean;
  logoUrl?: string;
  realIps: string[];
  reviewChange: {
    ciPermissionDocsReviewChange?: {
      name: string;
      url: string;
    }[];
    ciPermissionReviewChange?: CiPermission;
    logoUrlReviewChange?: string;
    logoUrlDeleted?: boolean;
    alimTalkImageUrlReviewChange?: string;
    alimTalkImageUrlDeleted?: boolean;
  };
  reviewRejectReason?: string;
  reviewStatus: SvcReviewStatusType;
  svcName: string;
  useWalletChannel: boolean;
  alimTalkImageUrl?: string;
};

export const getSvcDetails = (svcId: string) => {
  return api<PcApiResponse<SvcDetails>>('get', `/pc-api/v1/${PREFIX_PATH}/svc/details`, { svcId });
};
